<div ngbDropdown class="dropdown popout" placement="bottom-end">
    <button ngbDropdownToggle id="dropdownMenuButton" class="notification-btn" (click)="popup()">
        <img src="../../assets/icons/buttons/bell.png" alt="Popout">
    </button>
    <div class="notification-alert" *ngIf="hasNewAlert"></div>
    <div ngbDropdownMenu class="notification-dropdown">
        <div class="notification-title">New Notifications</div>
        <div class="notification-list">
            <div class="notification" *ngFor="let notification of notifications; let i = index"
                (click)="read(notification, true)" (touchstart)="swipeStart(notification, $event)" (touchend)="swipeEnd(notification, $event)">
                <div class="notification-desc">{{ notification.description }}</div>
                <div class="notification-date">{{ notification.dateAdded | date: 'dd MMMM | HH:mm' }}</div>
                <div class="notification-dot" *ngIf="!notification.isRead"></div>
            </div>
        </div>
        <div class="notification" *ngIf="noNotifications">
            <div class="notification-desc">No new notifications</div>
        </div>
        <div class="notification-view" (click)="viewAllNotifications()"><u>View Completed</u></div>
    </div>
</div>
